<template>
  <div id="firstTimeUserPopUp" style="display:none;" @click="hideFTU()">
    <img class="firstTimeImg" src="https://www.csub.edu/selfservice/images/myCSUB_FirstTimeUser.png"
      alt="myCSUB First time user guide" longdesc="http://www.csub.edu/its/new/index.html" />
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'ftu',
  data () {
    return { }
  },
  methods: {
    hideFTU: function () {
      $('#firstTimeUserPopUp').fadeOut(800)
      $('#main').fadeIn(800)
    }
  }
}
</script>

<style scoped>
  #firstTimeUserPopUp {
    cursor: pointer;
  }
</style>
